import React from "react";
import NavBar from "../components/homePage/navBar";
import CreateStore from "../components/store/createStore";

const CreateStorePage: React.FC = () => {
    return (
        <div>
            <NavBar />
            <CreateStore />
        </div>
    )
}

export default CreateStorePage;